import { render, staticRenderFns } from "./information.page.vue?vue&type=template&id=6bb66fb6&scoped=true&"
import script from "./information.page.vue?vue&type=script&lang=js&"
export * from "./information.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb66fb6",
  null
  
)

export default component.exports